import {cargoApiURL} from '@yandex-delivery/client-core/api/corp'

import type {FetchFunction} from '../fetch'

function createCargoApiUrlMiddleware() {
  function withCargoApiUrlMiddleware(fetchFn: FetchFunction): FetchFunction {
    return function cargoApiUrlFetch(config) {
      return fetchFn({
        ...config,
        url: cargoApiURL(config.url),
      })
    }
  }

  return withCargoApiUrlMiddleware
}

export {createCargoApiUrlMiddleware}
